import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PillButton from "./PillButton";

export default function FinalCTA() {
    return (
        <section
            id="contact"
            className="relative bg-alva-cta-gradient text-white py-28 md:py-40 overflow-hidden"
            data-testid="final-cta-section"
        >
<div
                aria-hidden
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none"
                style={{ background: "radial-gradient(closest-side, rgba(43,123,228,0.35), transparent 70%)" }}
            />

            <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8 }}
                    className="font-display font-black tracking-tighter text-balance"
                    style={{ fontSize: "clamp(36px, 7vw, 72px)", lineHeight: 1.02 }}
                    data-testid="final-cta-title"
                >
                    Prêt à avoir un vrai site
                    <br />
                    <span className="text-[#2B7BE4]">qui rapporte ?</span>
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="mt-6 text-lg md:text-xl text-white/70 max-w-2xl mx-auto"
                >
                    Audit gratuit, 30 minutes en visio. Sans engagement.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="mt-10 flex flex-col items-center gap-4"
                >
                    <PillButton
                        as={Link}
                        to="/audit-gratuit"
                        size="lg"
                        variant="whitePill"
                        className="text-lg px-10 py-5"
                        data-testid="final-cta-button"
                    >
                        Réserver mon audit
                        <ArrowRight size={20} />
                    </PillButton>
                    <p className="text-sm text-white/50">
                        Réponse sous 24h · Pas de pression commerciale
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
